export default {
  statusBadge: {
    draft: 'Draft',
    preprocessing: 'Preprocessing',
    awaitingUserMeshing: 'Awaiting Meshing',
    awaitingBcReview: 'Awaiting BC Review',
    awaitingMoboReview: 'Awaiting Review',
    running: 'Running',
    completed: 'Completed',
    completedWithIssues: 'Completed with Issues',
    failed: 'Failed',
    cancelled: 'Cancelled',
  },
  dashboard: {
    sortDateCreated: 'Date created',
    sortName: 'Name',
    moreFilters: 'More filters',
    typeFilter: 'Type',
    tagFilter: 'Tags',
    typeFea: 'FEA',
    typeCfd: 'CFD',
    typeCht: 'CHT',
    tagCfdExt: 'CFD · External',
    tagCfdInt: 'CFD · Internal',
    tagCht: 'CHT',
    tagFea: 'FEA',
    tagTet: 'Tet',
    tagHex: 'Hex',
    tagPoly: 'Poly',
    noTypes: 'No types',
    noTags: 'No tags',
    noStatuses: 'No statuses',
    clearFilter: 'Clear filter',
    selectAllStudies: 'Select all studies',
    selectStudy: 'Select {{name}}',
    colName: 'Name',
    colStatus: 'Status',
    colDesignPts: 'Design Pts',
    colProgress: 'Progress',
    colCreated: 'Created',
    colCompleted: 'Completed',
    colUpdated: 'Updated',
    colActions: 'Actions',
    startNewStudyTitle: 'Start a new study',
    startNewStudySubtitle: 'Set up a DOE, surrogate, or GCI study.',
    newStudy: 'New study',
    studies: 'Studies',
    studiesCount_one: '{{count}} study',
    studiesCount_other: '{{count}} studies',
    searchStudies: 'Search studies…',
    selectedCount_one: '{{count}} selected',
    selectedCount_other: '{{count}} selected',
    clear: 'Clear',
    delete: 'Delete',
    tabAll: 'All',
    tabDraft: 'Draft',
    tabRunning: 'Running',
    tabCompleted: 'Completed',
    tabFailed: 'Failed',
    emptyTitleNoStudies: 'No studies yet',
    emptyTitleNoMatch: 'No studies match your filters',
    emptyHintNoStudies: 'Click "New study" above to get started.',
    emptyHintNoMatch: 'Try a different filter or search term.',
    emptyHintSearchMore:
      'No matches in the loaded studies — scroll to load more, or try a different search.',
    loadingStudies: 'Loading studies…',
    tableEmpty: 'No studies available yet.',
    studyNameLabel: 'Study name',
    renameTooltip: '{{name}} — double-click to rename',
    renameFailed: 'Failed',
  },
  deleteDialog: {
    title_one: 'Delete {{count}} study?',
    title_other: 'Delete {{count}} studies?',
    description_one:
      "Removes this study and its results from your studies list. You can't undo this.",
    description_other:
      "Removes these {{count}} studies and their results from your studies list. You can't undo this.",
    cancel: 'Cancel',
    confirm_one: 'Delete {{count}} study',
    confirm_other: 'Delete {{count}} studies',
  },
  libraryCard: {
    points: '{{done}}/{{total}} pts',
  },
  reviewView: {
    evidence: 'Evidence',
  },
  userMeshing: {
    geometryFallback: 'geometry',
    sectionLabel: 'Design points · meshing',
    allFaceNamed_one: 'The {{count}} DP is face-named.',
    allFaceNamed_other: 'All {{count}} DPs are face-named.',
    readyWhenFaceNamed_one: 'Ready when the {{count}} DP is face-named.',
    readyWhenFaceNamed_other: 'Ready when all {{count}} DPs are face-named.',
    simsQueueHint: 'Sims will queue automatically after you confirm.',
    completeAndRun: 'Complete meshing & run simulations',
    atAGlance: 'Study at a glance',
    designPoints: 'Design points',
    meshTemplate: 'Mesh template',
    fromStudy: 'From study',
    meshesYoursTitle: 'Meshes are yours forever.',
    meshesYoursBody:
      "Anything you produce here also appears in standalone MeshGen. Cancelling the study doesn't delete them.",
    cancelStudy: 'Cancel study…',
    readOnlyTitle: 'View only',
    readOnlyPastMeshing:
      'Meshing is finished for this study. Open a mesh to look at it — changes here can no longer reach the runs.',
    readOnlyRole:
      'You can look at these meshes but not change them. Only the study owner or an editor can finish meshing.',
  },
  cancelStudy: {
    action: 'Cancel study…',
    cancelled: 'Study cancelled.',
    failed: 'Cancel did not go through.',
  },
  progress: {
    phaseNotUsed: 'Phase not used in this study',
    phaseRailAria: '{{label}}: {{done}} of {{total}} done',
    notUsed: 'not used',
    countActive_one: '{{count}} active',
    countActive_other: '{{count}} active',
    countFailed_one: '{{count}} failed',
    countFailed_other: '{{count}} failed',
    progress: 'Progress',
    designPointsComplete_one:
      '{{completed}} of {{count}} design point complete',
    designPointsComplete_other:
      '{{completed}} of {{count}} design points complete',
    failedCount_one: '{{count}} failed',
    failedCount_other: '{{count}} failed',
    meshing: 'Meshing',
    simulating: 'Simulating',
    completed: 'Completed',
    running: 'Running',
    pending: 'Pending',
    failed: 'Failed',
    cancelled: 'Cancelled',
    studyConfiguration: 'Study Configuration',
    noSolverSettings: 'No solver settings configured.',
    sweepVariables: 'Sweep variables',
    someDesignPointsFailed: 'Some design points failed.',
    failedDuringMeshing_one: '{{count}} failed during meshing',
    failedDuringMeshing_other: '{{count}} failed during meshing',
    failedDuringPreparation_one: '{{count}} failed during preparation',
    failedDuringPreparation_other: '{{count}} failed during preparation',
    failedDuringSimulation_one: '{{count}} failed during simulation',
    failedDuringSimulation_other: '{{count}} failed during simulation',
    timestampCreated: 'Created',
    timestampCompleted: 'Completed',
    timestampFailed: 'Failed',
    timestampCancelled: 'Cancelled',
    timestampStarted: 'Started',
    timestampUpdated: 'Updated',
  },
} as const;
